import React from "react"
import { Box, Typography, Button, Stack, Link, Container } from "@mui/material"
import RatingStars from "newcomponents/rating-stars"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { Row } from "reactstrap"
import logo from "../../assets/images/logo/logo-light.png"
export const IntroScreen = ({
  showCTAButtons = true,
  showRating = true,
  showFooterLinks = true,
  className = "",
  title1 = "Reputation You Can See,",
  title2 = "Results you can trust.",
  subtitle = "Built for trust-driven businesses.",
  buttonText = "Start Free Trial",
  onClick,
}) => {
  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: 6,
        position: "relative",
        overflow: "hidden",
        minHeight: "100vh",
      }}
    >
      {/* Logo */}
      <Stack direction="row" alignItems="center">
        <img
          src={logo}
          alt="Aeravue Logo"
          style={{ width: "100px", height: "100px" }}
        />
      </Stack>

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <h1
          style={{
            fontSize: "2.5rem",
            marginBottom: "1rem",
            color: "#fff",
            fontWeight: "400",
          }}
        >
          {title1}
        </h1>
        <h1
          style={{
            marginTop: "-1rem",
            fontSize: "2.5rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "#fff",
            textTransform: "capitalize",
          }}
        >
          {title2}
        </h1>
        <p
          style={{
            fontSize: "1.125rem",
            marginBottom: "1rem",
            color: "#fff",
          }}
        >
          {subtitle}
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <p style={{ color: "#fff" }}>Integrates with:</p>
          <img
            src="/logos/facebook.svg"
            alt="Facebook"
            style={{ width: "20px", height: "20px", filter: "invert(100%)" }}
          />
          <img
            src="/logos/google.svg"
            alt="Google"
            style={{ width: "20px", height: "20px", filter: "invert(100%)" }}
          />
          <img
            src="/logos/yelp.svg"
            alt="Yelp"
            style={{ width: "20px", height: "20px", filter: "invert(100%)" }}
          />
          <img
            src="/logos/linkedin.svg"
            alt="LinkedIn"
            style={{ width: "20px", height: "20px", filter: "invert(100%)" }}
          />
          <img
            src="/logos/instagram.svg"
            alt="Instagram"
            style={{ width: "20px", height: "20px", filter: "invert(100%)" }}
          />
          <p
            style={{
              color: "#fff",
              fontWeight: "400",
              fontSize: "0.875rem",
              textTransform: "uppercase",
            }}
          >
            +More
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={
              onClick ||
              (() => {
                console.log("clicked")
              })
            }
            style={{
              padding: "15px 35px",
              backgroundColor: "#47A0EA",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "400",
              fontSize: "1rem",
            }}
          >
            {buttonText || "Start Free Trial"}{" "}
            <span>
              <ArrowForwardIcon
                style={{
                  marginLeft: "4px",
                }}
              />
            </span>
          </button>
          <button
            style={{
              padding: "15px 25px",
              backgroundColor: "transparent",
              color: "#fff",
              border: "1px solid #fff",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Get a Demo
          </button>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "40px",
          }}
        >
          <p
            style={{
              color: "#FFB400",
              fontWeight: "700",
              fontSize: "28px",
              margin: 0, // remove default <p> margin
            }}
          >
            5.0
          </p>

          <RatingStars value={4.5} />
        </div>
        <p
          style={{
            color: "#fff",
            fontWeight: "600",
            fontSize: "0.875rem",
            textTransform: "capitalize",
          }}
        >
          Trusted by 500+ clinics & restaurants
        </p>
      </Box>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          color: "#fff",
          fontWeight: "400",
          marginTop: "30px",
        }}
      >
        <p style={{ color: "#fff", fontSize: "0.875rem" }}>
          By registering you agree to the Aeravue
        </p>
        <p
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            textTransform: "uppercase",
          }}
        >
          Terms of Use
        </p>
        <p
          style={{
            color: "#fff",
            fontSize: "0.875rem",
            textTransform: "uppercase",
          }}
        >
          |
        </p>
        <p
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            textTransform: "uppercase",
          }}
        >
          Privacy Policy
        </p>
      </div>
    </Box>
  )
}
